import { TranslateService } from 'ng2-translate';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalDetailComponent} from '../../modal-detail/modal-detail.component';
import {ModalUploadComponent} from '../../modal-upload/modal-upload.component';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import * as XLSX from 'xlsx';

const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';

@Component({
  selector: 'app-complement-payments-detail',
  templateUrl: './complement-payments-detail.component.html',
  styleUrls: ['./complement-payments-detail.component.scss']
})
export class ComplementPaymentsDetailComponent implements OnInit {
  loadBtn = false;

  userId: any;
  userToken: any;
  textButton: any;

  type: any;
  info: any = {};
  listCompanies: any;
  editId: any;
  numOrder: any;
  typeFileUpload: any;
  detailPayment: any;
  detailDocs: any;
  listInvoices = [];
  total = 0;


    // config carga de documentos //

    dataForeign: any = {};
    private base64textString: String = '';
    base64Pdf: string;
    filesUpload = 0;
    filesArr = [];
    cpCompany: any;
    diatanceCdfi: any;
    alertDistance = false;
    filesCountUpload = 0;
    showDrop = true;
    step = 1;
    msgResp: any;
    txtHead = 'BUTTONS.ADDINVOICE';
    totalSelect: any;

    uploader: FileUploader = new FileUploader({
      url: URL,
      isHTML5: true
    });

    hasBaseDropZoneOver = false;

  listTempData=[];

  language= 'es';
  listExport=[];
  languageTxt;
  checkedAll = false;
  sessionUserId;

  constructor(private toastr: ToastrService,
    private gralService: GeneralService,
    private provService: ProvidersService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ComplementPaymentsDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
    ) {

    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    this.type = this.data.type;
    this.info = this.data.data;
    console.warn('ejemplo ', this.data.sessionUserId);

    this.sessionUserId = this.data.userId;

    this.language = localStorage.getItem('language');

    this.textButton = 'Cargar complemento de pago';
    if(this.type == 'detail'){
      this.detailPayment = this.data.info;
    }

    if(this.type == 'docs'){
      this.detailDocs = this.data.info;
      this.total = this.data.total;
    }

    if(this.type == 'hist-invoices'){

      this.listInvoices = this.data.invoices;
    }

    this.editId = this.data.id;
  }

  ngOnInit() {
    setTimeout(()=>{
      if(this.type == 'docs'){
        this.orderDataDetailDocs();

      }else if(this.type == 'hist-invoices'){
        this.orderDataExport();

      }

    }, 1000);

  }

  viewFile(url){

    let type = 'view_jpg';
    const last = url.split('.').pop();
    if(last == 'pdf'){
      type = 'view_pdf';
    }

    this.dialog.open(ModalDetailComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: {type: type, url: url, title: 'Documento'}
    });
  }

  uploadInvoice(){
    const params = {
      xmlBase64: null,
      pdfBase64: null,
      numeroProveedor: '12323',
      claveEmpresa: '23443',
      tipoOrden: 5,
      pagoSAP: {Items: this.detailDocs}
    };

    const dialogRef = this.dialog.open(ModalUploadComponent, {
      minWidth: '70%',
      position: {
        top: '6%'
      },
      data: { type: 'complement', data: params }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.onCloseConfirm();
      }
    });
  }

  send(){
    console.log('senddddd');
  }

  onCloseConfirm() {
    // this.dialogRef.close({ data: true });
    this.dialogRef.close({ data: true, status:'update' } );
  }

  onCloseCancel() {
    this.dialogRef.close();
  }


  //////////////////////////// carga de factura
  upp(evt){
    const file = evt.dataTransfer ? evt.dataTransfer.files[0] : evt.target.files[0];
    this.fileUpload(file);
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  dropped(e){
    for(let g = 0; g < e.length; g++){
      this.fileUpload(e[g]);
    }
  }

  fileUpload(file){
    const exist = this.filesArr.find(x => x.name == file.name);
    if(exist){
      this.toastr.error('El archivo ' + file.name + ' ya esta en la lista.', 'Error al cargar archivo');
      return false;
    }

    const pattern = /image-*/;
    const patternPdf = /pdf/;
    const patternXml = /xml/;

    if(this.filesCountUpload < 2){
      if (!file.type.match(patternPdf)) {
        if (!file.type.match(patternXml)) {
          this.toastr.error('El archivo ' + file.name + ' tiene formato de archivo inválido, solo se acepta pdf y xml', 'Error al cargar archivo');
          return false;
        }else{
          this.filesArr.push({file: file, name: file.name, size: file.size, color: 'green', type: 'xml', date: '11-07-2018', error: null, id: 13, url: null});
        }
      }else{
        this.filesArr.push({file: file, name: file.name, size: file.size, color: 'green', type: 'pdf', date: null, error: null, id: null, url: 'http://concent.com.mx'});
      }

      this.filesCountUpload++;
      if(this.filesCountUpload >= 2){
        this.showDrop = false;
      }
    }
  }

  _loadxml(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    this.info.xmlBase64 = btoa(binaryString);
  }


  _loadPdf(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64Pdf = btoa(binaryString);
    this.info.pdfBase64 = btoa(binaryString);
  }

  deleteFile(idx){
    this.filesArr.splice(idx, 1);
    this.filesCountUpload--;
    if(this.filesCountUpload < 2){
      this.showDrop = true;
    }
  }

  upload(){
    console.warn(this.type);
    if(this.filesArr.length == 0){
      this.toastr.error('Favor de agregar la factura', 'Error al cargar archivo');
      return false;
    }

    this.loadBtn = true;
    let existXml = false;

    for(let g = 0; g < this.filesArr.length; g++){
      if(this.filesArr[g].type == 'xml'){
        const reader = new FileReader();
        reader.onload = this._loadxml.bind(this);
        reader.readAsBinaryString(this.filesArr[g].file);
        existXml = true;
      }

      if(this.filesArr[g].type == 'pdf'){
        const reader = new FileReader();
        reader.onload = this._loadPdf.bind(this);
        reader.readAsBinaryString(this.filesArr[g].file);
      }
    }

    setTimeout(() => {
      if(this.type == 'foreignConsignments'){
        if(!this.dataForeign.serie || !this.dataForeign.folio || !this.dataForeign.rfcEmisor || !this.dataForeign.fechaEmision || !this.dataForeign.rfcReceptor || !this.dataForeign.subTotal){
          this.toastr.error('Favor de agregar los datos obligatorios', 'Error al cargar archivo');
          this.loadBtn = false;
          return false;
        }

        this.info.xmlBase64 = undefined;
        this.info.facturaPdf = this.dataForeign;

        this.provService.uploadPdfForeign(this.info, this.userToken).then((data) => {
          this.loadBtn = false;

          let msgs = '';
          for(let g = 0; g < data['listaMensajes'].length; g++){
            console.log(data['listaMensajes'][g])
            msgs = msgs+'<br>- '+data['listaMensajes'][g];
          }
          this.msgResp = msgs;

          if(data['resultado']){
            this.toastr.success('Archivo correcto', 'Cargar archivo');
            this.step = 2;
          }else{
            this.toastr.error('Error al cargar archivo', 'Cargar archivo');
            return;
          }
        }, (err) => {
          console.log(err);
          this.loadBtn = false;
          this.toastr.error('Error al cargar archivo', 'Cargar archivo');
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });


      }

      if(this.type == 'foreign'){
        if(!this.dataForeign.serie || !this.dataForeign.folio || !this.dataForeign.moneda || !this.dataForeign.fechaEmision || !this.dataForeign.rfcReceptor || !this.dataForeign.subTotal){
          this.toastr.error('Favor de agregar los datos obligatorios', 'Error al cargar archivo');
          this.loadBtn = false;
          return false;
        }
        this.info.xmlBase64 = undefined;
        this.info.facturaExtranjeros = this.dataForeign;

        this.provService.uploadPdfForeign(this.info, this.userToken).then((data) => {
          this.loadBtn = false;

          let msgs = '';
          for(let g = 0; g < data['listaMensajes'].length; g++){
            msgs = msgs+'<br>- '+data['listaMensajes'][g];
          }
          this.msgResp = msgs;

          if(data['resultado']){
            this.toastr.success('Archivo correcto', 'Cargar archivo');
            this.step = 2;
          }else{
            this.toastr.error('Error al cargar archivo', 'Cargar archivo');
            return;
          }
        }, (err) => {
          console.log(err);
          this.loadBtn = false;
          this.toastr.error('Error al cargar archivo', 'Cargar archivo');
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }else{
        if(!existXml){
          this.loadBtn = false;
          this.toastr.error('Favor de agregar el archivo XML', 'Error al cargar archivo');
          return false;
        }

        if(this.type == 'consignments'){
          this.info.IdUsuarioSeleccion = this.userId;
          this.info.IdUsuarioSeleccion = this.data.sessionUserId;
          console.log('lol',this.sessionUserId);
          this.provService.uploadCfdiConsignment(this.info, this.userToken).then((data) => {
            this.loadBtn = false;
            console.log(data);
            let msgs = '';
            for(let g = 0; g < data['listaMensajes'].length; g++){
              msgs = msgs+'<br>- '+data['listaMensajes'][g];
            }
            this.msgResp = msgs;

            if(data['resultado']){
              this.toastr.success('Archivo correcto', 'Cargar archivo');
              this.step = 2;
            }else{
              this.toastr.error('Error al cargar archivo', 'Cargar archivo');
              return;
            }
          }, (err) => {
            //console.log(err);
            this.loadBtn = false;
            this.toastr.error('Error al cargar archivo', 'Cargar archivo');
            if(err.status == 401){
              this.gralService.actDeacUser(false);
            }
          });
        //}else if(this.type == 'complement'){ hist-invoices
        }else if(this.type == 'docs'){

          //this.info.IdUsuarioSeleccion = this.userId;
          this.info.IdUsuarioSeleccion = this.data.sessionUserId;
          // console.log('aquí se debe enviar',this.info);
          // console.log('lol',this.sessionUserId);

          this.provService.uploadCfdiComplement(this.info, this.userToken).then((data) => {
            this.loadBtn = false;
            let msgs = '';
            for(let g = 0; g < data['listaMensajes'].length; g++){
              //this.toastr.error(data['listaMensajes'][g], 'Cargar archivo');
              msgs = msgs+'<br>- '+data['listaMensajes'][g];
            }
            this.msgResp = msgs;

            if(data['resultado']){
              this.toastr.success('Archivo correcto', 'Cargar archivo');
              this.step = 2;
            }else{
              this.toastr.error('Error al cargar archivo', 'Cargar archivo');
              return;
            }
          }, (err) => {
            console.log(err);
            this.loadBtn = false;
            this.toastr.error('Error al cargar archivo', 'Cargar archivo');
            if(err.status == 401){
              this.gralService.actDeacUser(false);
            }
          });
        }else{
          this.provService.uploadCfdi(this.info, this.userToken).then((data) => {
            this.loadBtn = false;
            console.log(data);
            let msgs = '';
            for(let g = 0; g < data['listaMensajes'].length; g++){
              msgs = msgs+'<br>- '+data['listaMensajes'][g];
            }
            this.msgResp = msgs;

            if(data['resultado']){
              this.toastr.success('Archivo correcto', 'Cargar archivo');
              this.step = 2;
            }else{
              this.toastr.error('Error al cargar archivo', 'Cargar archivo');
              return;
            }
          }, (err) => {
            console.log(err);
            this.loadBtn = false;
            this.toastr.error('Error al cargar archivo', 'Cargar archivo');
            if(err.status == 401){
              this.gralService.actDeacUser(false);
            }
          });
        }
      }

    }, 1000);
  }

  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    //const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listpayments);
    console.log(this.listExport);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listExport);

    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    if(this.type == 'hist-invoices'){
      XLSX.writeFile(workbook, this.toExportFileName('CFDIS_complemento'));
    }else if(this.type == 'docs'){
      XLSX.writeFile(workbook, this.toExportFileName('facturas_complemento'));
    }

  }


  orderDataExport(){
    this.listExport = [];

    this.translate.getTranslation(this.language).subscribe((res:any)=>{
      this.languageTxt = res;

      let list = this.listInvoices;

      for(let i = 0; i < list.length; i++){
        let param ={} ;
        param[this.languageTxt.TBLHEADS.FOLIO] = list[i].Folio;
        param[this.languageTxt.TBLHEADS.DATE] = list[i].Fecha;
        param[this.languageTxt.TBLHEADS.AMOUNT] = list[i].Importe;
        param[this.languageTxt.TBLHEADS.CURRENCY] = list[i].Moneda;
        param[this.languageTxt.TBLHEADS.TYPEDOC] = list[i].TipoDeDocumento;
        param['UUID'] = list[i].UUID;

        this.listExport.push(param);
      }

    });
  }

  orderDataDetailDocs(){
    this.listExport = [];

    console.log(this.detailDocs);
    this.translate.getTranslation(this.language).subscribe((res:any)=>{
      this.languageTxt = res;
      console.log(this.detailDocs);
      let list = this.detailDocs;

      for(let i = 0; i < list.length; i++){
        let param ={} ;
        console.log(list[i].DOC_NO);

        param[this.languageTxt.TBLHEADS.FOLIO] = list[i].DOC_NO;
        param[this.languageTxt.TBLHEADS.REFERENCE] = list[i].REF_DOC_NO;
        param[this.languageTxt.TBLHEADS.DATE] = list[i].DOC_DATE;
        param[this.languageTxt.TBLHEADS.CURRENCY] = list[i].CURRENCY;
        param[this.languageTxt.TBLHEADS.AMOUNT] = list[i].AMT_DOCCUR_DEC;
        param[this.languageTxt.TBLHEADS.PLANT] = list[i].BUS_AREA;
        param['UUID'] = list[i].UUID;

        this.listExport.push(param);
      }

      console.log(this.listExport);
    });
  }



}
